export default __webpack_public_path__ + "static/Roobert-Bold-9ac1350e344eec7189b31d32d3316fff.woff2";